import React from "react";
import { Link } from "react-router-dom";
import "../styles/ProcessFlow.css";
import flow from "../images/flow-image.png";
import process1 from "../images/process1.png";
import process2 from "../images/process2.png";
import process3 from "../images/process3.png";
import process4 from "../images/process4.png";
import process5 from "../images/process5.png";

function ProcessFlow() {
  return (
    <div className="process-flow-section" id="process-flow">
      <h2 className="process-flow-title">運用開始までの流れ</h2>
      <img src={flow} alt="flow" className="flow-image" />
      <div className="process-steps">
        <div className="step-card">
          <div className="step-content">
            <div className="step-text">
              <div className="step-container">
                <h3 className="step-number">Step 1</h3>
                <h4 className="step-title">お問い合わせ</h4>
              </div>
              <p className="step-description">
                まずはお気軽にお問い合わせください。
                <br />
                サービスに対するご質問や公式LINE活用方法など柔軟にご相談承ります。
              </p>
              <Link to="/inquiry" className="process-button">
                問い合わせをする
              </Link>
            </div>
            <img src={process1} alt="Step 1" className="step-image" />
          </div>
        </div>

        <div className="step-card">
          <div className="step-content">
            <div className="step-text">
              <div className="step-container">
                <h3 className="step-number">Step 2</h3>
                <h4 className="step-title">ヒアリング</h4>
              </div>
              <p className="step-description">
                お客様のビジネスの状況やご要望をお伺いし、必要な要件に沿って機能の開発や目指す方向などについて確認を行います。
              </p>
            </div>
            <img src={process2} alt="Step 2" className="step-image" />
          </div>
        </div>

        <div className="step-card">
          <div className="step-content">
            <div className="step-text">
              <div className="step-container">
                <h3 className="step-number">Step 3</h3>
                <h4 className="step-title">ご契約・公式LINE導入</h4>
              </div>
              <p className="step-description">
                Linectのご利用を希望いただける場合は、契約手続きに移らせていただきます。
                <br />
                ご契約後、開発に必要な環境準備や設定を行います。
              </p>
            </div>
            <img src={process3} alt="Step 3" className="step-image" />
          </div>
        </div>

        <div className="step-card">
          <div className="step-content">
            <div className="step-text">
              <div className="step-container">
                <h3 className="step-number">Step 4</h3>
                <h4 className="step-title">システム開発</h4>
              </div>
              <p className="step-description">
                お客様のご要望やヒアリング内容をもとに、必要なシステムの設計・開発を行います。
              </p>
            </div>
            <img src={process4} alt="Step 4" className="step-image" />
          </div>
        </div>

        <div className="step-card">
          <div className="step-content">
            <div className="step-text">
              <div className="step-container">
                <h3 className="step-number">Step 5</h3>
                <h4 className="step-title">運用開始</h4>
              </div>
              <p className="step-description">
                開発したLINEシステムのリリースを行います。 <br />
                運用方法や使い方など、実際に使用できるまで伴走してご支援いたします。
                <br />
                また、集客やビジネスの観点からもシステムの最大活用ができるようにアドバイスいたします。
              </p>
            </div>
            <img src={process5} alt="Step 5" className="step-image" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProcessFlow;
